import Main from './main.vue'
export default Main



// WEBPACK FOOTER //
// ./src/components/main/index.js